"use client";

import { Field, FieldError, FieldLabel } from "@repo/ui/form-fields";
import { type CodeValue, fromCodeableConcept, toCodeableConcept } from "@/shared/forms/code-value";
import { useFieldContext } from "@/shared/forms/form-context";
import { MedicationPicker } from "@/shared/pickers/medication-picker";

export interface MedicationFieldProps {
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

/** Bridges the FHIR-speaking picker to flat `CodeValue` form state, as `IcdCodeField` does. */
export function MedicationField({ label, placeholder, disabled }: MedicationFieldProps) {
  const field = useFieldContext<CodeValue | undefined>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <MedicationPicker
        value={field.state.value ? toCodeableConcept(field.state.value) : undefined}
        onChange={(v) => {
          field.handleChange(fromCodeableConcept(v));
          field.handleBlur();
        }}
        placeholder={placeholder}
        disabled={disabled}
      />
      <FieldError />
    </Field>
  );
}
